<template>
  <div
    class="fixed top-0 left-0 flex items-center justify-center w-full h-screen text-textcolor-dark"
  >
    <div class="folder-modal-wrapper">
      <div class="folder-modal-header">
        <h2 class="m-0 text-textcolor">Select file or template</h2>
      </div>
      <div class="flex flex-1">
        <div class="folder-sidebar">
          <span
            class="folder-sidebar-item hover:bg-primary-light hover:text-white"
            :class="selectedFolder === folder && 'bg-primary-light text-white'"
            v-for="folder in folders"
            :key="folder.folderName"
            @click="selectFolder(folder)"
            >{{ folder.folderName }}</span
          >
        </div>
        <div class="flex flex-col flex-1" v-if="selectedFolder">
          <div class="flex items-center flex-none">
            <span
              class="flex-1 p-2 text-center text-white cursor-pointer bg-primary-dark folder-tab-item"
              :class="selectedArea === 'FILE' && 'selected-area'"
              @click="selectArea('FILE')"
              >File</span
            >
            <span
              class="flex-1 p-2 text-center text-white cursor-pointer bg-primary-dark folder-tab-item"
              :class="selectedArea === 'TEMPLATE' && 'selected-area'"
              @click="selectArea('TEMPLATE')"
              >Template</span
            >
          </div>
          <div class="pb-8 overflow-y-auto h-96">
            <div class="flex flex-col flex-1 " v-if="selectedArea === 'FILE'">
              <span
                @click="selectFile(file)"
                v-for="file in selectedFolder.files"
                :key="file"
                :class="selectedFile === file && 'bg-primary-light'"
                class="flex px-4 py-2 text-center text-white cursor-pointer hover:bg-primary-light"
              >
                {{ file }}
              </span>
            </div>
          </div>
          <div
            class="flex flex-col flex-1 p-6"
            v-if="selectedArea === 'TEMPLATE'"
          >
            <div
              class="flex items-center w-64 overflow-hidden border border-solid rounded-lg border-highlight text-highlight"
            >
              <span
                class="flex items-center justify-center flex-1 px-2 py-1 text-xs font-semibold text-center cursor-pointer hover:bg-highlight hover:text-white"
                @click="selectedTemplateType = 'VARIABLE'"
                :class="
                  selectedTemplateType === 'VARIABLE' &&
                    'bg-highlight text-white'
                "
              >
                Variable
              </span>
              <span
                @click="selectedTemplateType = 'PRESET'"
                class="flex items-center justify-center flex-1 px-2 py-1 text-xs font-semibold text-center cursor-pointer hover:bg-highlight hover:text-white"
                :class="
                  selectedTemplateType === 'PRESET' && 'bg-highlight text-white'
                "
                >Preset</span
              >
            </div>

            <drop-down
              placeholder="Select variable"
              v-model="selectedVariable"
              value-property="name"
              search-prop="name"
              :options="variables"
              v-if="selectedTemplateType === 'VARIABLE'"
            />
            <drop-down
              placeholder="Select preset"
              v-model="selectedPreset"
              value-property="name"
              search-prop="name"
              :options="presets"
              v-if="selectedTemplateType === 'PRESET'"
            />
            <drop-down
              placeholder="Select file extension"
              value-property="name"
              search-prop="name"
              v-model="selectedExtension"
              :options="extensions"
            />
          </div>
        </div>
      </div>
      <div class="flex items-center p-4 mt-auto bg-primary-dark">
        <div class="flex items-center ml-auto">
          <button
            type="button"
            class="px-4 py-2 mr-4 font-semibold bg-transparent border-solid rounded cursor-pointer border-highlight text-highlight hover:bg-highlight hover:text-white"
            @click="$emit('close')"
          >
            Close
          </button>
          <button
            class="px-4 py-2 font-semibold text-white border-solid rounded cursor-pointer bg-highlight border-highlight"
            type="button"
            @click="saveSelection"
          >
            Save
          </button>
        </div>
      </div>
    </div>
    <div
      @click="$emit('close')"
      class="fixed top-0 left-0 z-10 w-full h-screen opacity-75 bg-primary-dark"
    ></div>
  </div>
</template>

<script>
import DropDown from "./forms/DropDown.vue";
export default {
  components: {
    DropDown,
  },
  props: {
    folders: { type: Array },
    variables: { type: Array },
    variable: { type: Object },
  },
  data() {
    return {
      selectedFolder: null,
      selectedFile: null,
      selectedArea: "FILE",
      selectedVariable: null,
      selectedTemplateType: "VARIABLE",
      extensions: [
        { name: ".jpg" },
        { name: ".jpeg" },
        { name: ".png" },
        { name: ".bmp" },
        { name: ".jpe" },
        { name: ".jfif" },
        { name: ".git" },
        { name: ".tif" },
        { name: ".tiff" },
        { name: ".wmf" },
        { name: ".emf" },
        { name: ".ico" },
        { name: ".pcx" },
        { name: ".psd" },
        { name: ".pdf" },
        { name: ".svg" },
      ],
      selectedExtension: null,
      presets: [{ name: "EXTERNALIDENTIFIER" }, { name: "ARTICLENAME" }],
      selectedPreset: null,
    };
  },
  methods: {
    selectFolder(folder) {
      this.selectedFolder = folder;
    },
    selectFile(file) {
      this.selectedFile = file;
    },
    selectArea(area) {
      this.selectedArea = area;
    },
    saveSelection() {
      if (this.selectedArea === "TEMPLATE") {
        let file;
        if (this.selectedTemplateType === "VARIABLE") {
          file = `#${this.selectedVariable.name.toUpperCase()}#${
            this.selectedExtension.name
          }`;
        }

        if (this.selectedTemplateType === "PRESET") {
          file = `#${this.selectedPreset.name.toUpperCase()}#${
            this.selectedExtension.name
          }`;
        }

        this.$emit("saveSelection", {
          folder: this.selectedFolder.folderName,
          file,
        });
      } else {
        this.$emit("saveSelection", {
          folder: this.selectedFolder.folderName,
          file: this.selectedFile,
        });
      }
    },
  },
  mounted() {
    const folderFileName = this.variable.value.split(":")[1];

    const folderName = folderFileName.split("/")[0];
    const fileName = folderFileName.split("/")[1];

    if (fileName.includes("#")) {
      this.selectedArea = "TEMPLATE";

      if (fileName.includes("EXTERNALIDENTIFIER")) {
        this.selectedTemplateType = "PRESET";
        this.selectedPreset = this.presets[0];
      } else if (fileName.includes("ARTICLENAME")) {
        this.selectedTemplateType = "PRESET";
        this.selectedPreset = this.presets[1];
      } else {
        this.selectedTemplateType = "VARIABLE";
        this.selectedVariable = this.variables.find(x =>
          fileName.includes(x.name.toUpperCase())
        );
      }

      const extension = fileName.split(".").pop();

      this.selectedExtension = this.extensions.find(
        x => x.name === `.${extension}`
      );
    } else {
      this.selectedArea = "FILE";
      this.selectedFile = fileName;
    }

    this.selectedFolder =
      this.folders && this.folders.find(x => x.folderName === folderName);
  },
};
</script>

<style lang="postcss" scoped>
.folder-modal-wrapper {
  @apply z-50 flex flex-col overflow-hidden bg-primary rounded;
  width: 800px;
  height: 600px;
}
.folder-modal-header {
  @apply w-full text-center flex items-center m-0 justify-center p-6 flex-none;
  border-bottom: 1px solid theme("colors.primary-dark");
}
.folder-sidebar {
  @apply flex flex-col w-32 flex-none;
  border-right: 1px solid theme("colors.primary-dark");
}

.folder-sidebar-item {
  @apply text-center p-4 cursor-pointer text-white;
  border-bottom: 1px solid theme("colors.primary-dark");
}

.folder-tab-item {
  border-bottom: 2px solid transparent;
}

.selected-area {
  border-bottom-color: theme("colors.highlight");
}
</style>
